import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 13"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.4.526H1.6c-.424 0-.831.18-1.131.502C.169 1.349 0 1.786 0 2.24v8.572c0 .454.169.89.469 1.212s.707.502 1.131.502h12.8c.424 0 .831-.18 1.131-.502s.469-.758.469-1.212V2.24c0-.454-.169-.89-.469-1.212A1.55 1.55 0 0 0 14.4.526M1.6 10.812V5.669h12.8v5.143z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.8 7.383H3.2a.77.77 0 0 0-.566.251.9.9 0 0 0-.234.606.9.9 0 0 0 .234.606c.15.161.354.251.566.251h1.6c.212 0 .416-.09.566-.25A.9.9 0 0 0 5.6 8.24a.9.9 0 0 0-.234-.606.77.77 0 0 0-.566-.251m6.4 0h-4a.77.77 0 0 0-.566.251.9.9 0 0 0-.234.606.9.9 0 0 0 .234.606c.15.161.354.251.566.251h4c.212 0 .416-.09.566-.25A.9.9 0 0 0 12 8.24a.9.9 0 0 0-.234-.606.77.77 0 0 0-.566-.251"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }